import React, { useEffect, useState } from 'react';
import { Body, Box, Divider, Icon } from '@hover/blueprint';
import { iX } from '@hover/icons';
import styled from '@emotion/styled';
import { Progress } from '../../ui';

interface Props {
  isActive: boolean;
  content: string;
  title: string;
  body?: string;
}

export const RotateIcon = styled(Icon)`
  transform: rotateZ(${props => (props.isActive ? 0 : '45deg')});
  transition: all 0.2s ease;
`;

const CollapseItem: React.FC<Props> = ({ isActive, content, title, body }) => {
  const [mounted, setMounted] = useState<boolean>(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <Box flexDir="column" transition="all 0.3s ease">
      {isActive && mounted ? (
        <Progress duration={6.5} />
      ) : (
        <Divider color="neutral.300" opacity={1} my={0} />
      )}
      <Box
        flexDir="row"
        mt={isActive ? 700 : '26px'}
        mb={isActive ? 200 : '26px'}
      >
        <RotateIcon mr={400} icon={iX} isActive={isActive} size="default" />
        <Body size={600} isSemiBold>
          {title}
        </Body>
      </Box>
      <Box
        transition="all 0.3s linear"
        mb={isActive ? 700 : 0}
        ml="45px"
        maxH={isActive ? '1000px' : 0}
        opacity={isActive ? 1 : 0}
        flexDir="column"
        overflow="hidden"
      >
        <Body>{content}</Body>
        {body ? <Body mt={600}>{body}</Body> : null}
      </Box>
    </Box>
  );
};

CollapseItem.defaultProps = {
  body: '',
};

export default CollapseItem;
